import React from 'react';

const CoinDetailsText = ({ text }) => {
  return (
    <div className="h-full bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Details</h3>
      </div>
      <div className="px-4 py-3 sm:px-6">
        {text ? (
          <div 
            className="prose prose-sm max-w-none prose-ul:list-disc prose-ol:list-decimal prose-ul:pl-5 prose-ol:pl-5 prose-li:my-0 prose-p:my-0"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <p className="text-sm text-gray-900">-</p>
        )}
      </div>
    </div>
  );
};

export default CoinDetailsText;
